/**
 * Etiqueta de Caixa com QR Code.
 * Imprime em folhas A4 com 6 etiquetas por página (grelha 2x3).
 * Cada etiqueta ocupa ~98 x 90 mm (acompanha bem a A6).
 */
const LOGO_EP3D = "https://customer-assets.emergentagent.com/job_89a536dc-36dd-4821-ba4f-a6c069ebdb60/artifacts/u7v2hasx_Logotipo.png";

function buildLabelHTML(label) {
  // QR aponta para a pagina publica de info da caixa.
  // Qualquer leitor moderno (camera do telemovel, app QR) abre automaticamente o URL.
  const baseUrl = (typeof window !== "undefined" && window.location && window.location.origin) || "https://ep3d.me";
  const url = `${baseUrl}/box/${encodeURIComponent(label.lot_number)}`;
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=180x180&margin=0&ecc=M&data=${encodeURIComponent(url)}`;
  const created = new Date(label.created_at);
  const dateStr = created.toLocaleDateString("pt-PT");
  const timeStr = created.toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" });

  return `
  <div class="label">
    <div class="head">
      <div style="display:flex; align-items:center; gap:4px;">
        <img src="${LOGO_EP3D}" alt="EP3D" />
        <div>
          <div class="brand">EP3D</div>
          <div class="brand-tag">Etiqueta Caixa</div>
        </div>
      </div>
      <div class="lot">${label.lot_number}</div>
    </div>
    <div class="body">
      <div class="info">
        <div class="row"><span class="lbl">Peça</span><span class="val big">${label.part_code}</span></div>
        <div class="row"><span class="lbl">Descrição</span><span class="val small">${label.part_description || "-"}</span></div>
        <div class="row"><span class="lbl">Ordem</span><span class="val">${label.order_code}</span></div>
        <div class="row"><span class="lbl">Cliente</span><span class="val small">${label.client_name || "-"}</span></div>
        <div class="row"><span class="lbl">Caixa nº</span><span class="val">${label.box_number}</span></div>
        <div class="row"><span class="lbl">Qtd</span><span class="val big">${(label.quantity || 0).toLocaleString("pt-PT")} un</span></div>
        <div class="row"><span class="lbl">Peso</span><span class="val big">${(label.weight_kg || 0).toFixed(2)} kg</span></div>
        <div class="row"><span class="lbl">Operador</span><span class="val">${label.operator_code || "-"}</span></div>
      </div>
      <div class="qr">
        <img src="${qrUrl}" alt="QR" />
      </div>
    </div>
    <div class="foot">
      <span>EP3D · ${dateStr} ${timeStr}</span>
      <span>Turno: ${label.shift || "-"}</span>
    </div>
  </div>`;
}

function buildPageHTML(labels, opts = {}) {
  // Agrupar em paginas de 12 etiquetas
  const PER_PAGE = 12;
  const pages = [];
  for (let i = 0; i < labels.length; i += PER_PAGE) {
    pages.push(labels.slice(i, i + PER_PAGE));
  }
  const pagesHTML = pages.map((pageLabels) => {
    // Preencher slots vazios para manter grid uniforme
    const slots = [...pageLabels];
    while (slots.length < PER_PAGE) slots.push(null);
    const inner = slots.map(l => l ? buildLabelHTML(l) : '<div class="label empty"></div>').join("");
    return `<div class="sheet">${inner}</div>`;
  }).join("");

  return `<!DOCTYPE html>
<html lang="pt">
<head>
<meta charset="utf-8" />
<title>Etiquetas Caixa - ${labels.length} unidades</title>
<style>
  @page { size: A4 portrait; margin: 6mm; }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  html, body { font-family: 'Segoe UI', Arial, sans-serif; color: #0f172a; }
  body { font-size: 8.5px; }

  .sheet {
    width: 198mm;       /* A4 width 210 - 12mm margins */
    page-break-after: always;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, 68mm);
    gap: 2mm;
  }
  .sheet:last-child { page-break-after: auto; }

  .label {
    border: 1.5px solid #0f172a;
    padding: 1.5mm;
    display: grid;
    grid-template-rows: auto 1fr auto;
    overflow: hidden;
  }
  .label.empty { border: 1px dashed #cbd5e1; }

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #1e40af;
    padding-bottom: 0.8mm;
    margin-bottom: 0.8mm;
  }
  .head img { height: 13px; }
  .brand { font-weight: 900; font-size: 8px; color: #0f172a; letter-spacing: -0.2px; line-height: 1; }
  .brand-tag { font-size: 4.5px; color: #1e40af; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; }
  .lot { background: #0f172a; color: #fff; padding: 1px 3px; border-radius: 2px; font-family: 'Courier New', monospace; font-weight: 700; font-size: 6.5px; }

  .body { display: grid; grid-template-columns: 1fr 18mm; gap: 1.2mm; align-items: start; }
  .info .row { display: flex; gap: 1mm; padding: 0.3mm 0; border-bottom: 1px dotted #cbd5e1; align-items: baseline; }
  .info .row:last-child { border-bottom: none; }
  .info .lbl { color: #64748b; font-size: 5px; text-transform: uppercase; font-weight: 700; min-width: 10mm; }
  .info .val { font-weight: 700; color: #0f172a; flex: 1; font-size: 7px; }
  .info .val.big { font-size: 8.5px; color: #f97316; }
  .info .val.small { font-size: 6px; }

  .qr { display: flex; flex-direction: column; align-items: center; justify-content: flex-start; }
  .qr img { width: 17mm; height: 17mm; }

  .foot {
    font-size: 5px;
    color: #64748b;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #e2e8f0;
    padding-top: 0.5mm;
    margin-top: 0.5mm;
  }

  .toolbar {
    position: fixed;
    top: 8px;
    right: 8px;
    display: flex;
    gap: 6px;
    z-index: 1000;
  }
  .toolbar button {
    background: #f97316;
    color: #fff;
    border: none;
    padding: 6px 12px;
    border-radius: 3px;
    cursor: pointer;
    font-weight: 700;
    font-size: 11px;
  }
  @media print {
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    .toolbar { display: none; }
  }
</style>
</head>
<body>
<div class="toolbar"><button onclick="window.print()">🖨️ Imprimir ${labels.length} etiqueta${labels.length === 1 ? "" : "s"}</button></div>
${pagesHTML}
<script>
${opts.autoPrint ? "window.addEventListener('load', () => setTimeout(() => window.print(), 600));" : ""}
</script>
</body>
</html>`;
}

/**
 * Imprime UMA etiqueta (compatibilidade) - usa folha A4 com 1 etiqueta apenas (5 slots vazios).
 */
export function openBoxLabel(label, opts = {}) {
  return openBoxLabels([label], opts);
}

/**
 * Imprime VÁRIAS etiquetas em folha A4 com 6 por página.
 */
export function openBoxLabels(labels, opts = {}) {
  if (!labels || labels.length === 0) {
    alert("Não há etiquetas para imprimir.");
    return;
  }
  const html = buildPageHTML(labels, opts);
  const w = window.open("", "_blank", "width=900,height=1100");
  if (!w) {
    alert("Bloqueado pelo browser. Permita pop-ups para imprimir.");
    return;
  }
  w.document.write(html);
  w.document.close();
}
